export enum ProjectPlusSettingsTabsEnum {
  SETTINGS = 'SETTINGS',
  FILTERS = 'FILTERS',
  HIDDEN = 'HIDDEN',
}
